import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75 4.625C5.75 3.38236 6.75736 2.375 8 2.375C9.24264 2.375 10.25 3.38236 10.25 4.625C10.25 5.86764 9.24264 6.875 8 6.875C6.75736 6.875 5.75 5.86764 5.75 4.625ZM8 0.875C5.92893 0.875 4.25 2.55393 4.25 4.625C4.25 6.69607 5.92893 8.375 8 8.375C10.0711 8.375 11.75 6.69607 11.75 4.625C11.75 2.55393 10.0711 0.875 8 0.875ZM5 9.125C3.92059 9.125 2.8964 9.45392 2.12894 10.1036C1.34959 10.7633 0.875 11.7228 0.875 12.875V14C0.875 14.6213 1.37868 15.125 2 15.125H14C14.6213 15.125 15.125 14.6213 15.125 14V12.875C15.125 11.7228 14.6504 10.7633 13.8711 10.1036C13.1036 9.45392 12.0794 9.125 11 9.125H5ZM2.375 12.875C2.375 12.1632 2.65593 11.6227 3.09809 11.2485C3.55214 10.8641 4.21545 10.625 5 10.625H11C11.7845 10.625 12.4479 10.8641 12.9019 11.2485C13.3441 11.6227 13.625 12.1632 13.625 12.875V13.625H2.375V12.875Z"
      fill="white"
      fillOpacity={0.85}
    />
  </svg>
);
export default SVGComponent;
